import { buildNavigationPayload } from '@/utils/navigationTracking';

export default defineNuxtPlugin(function () {
  /** This code checks if the dataLayer array exists and contains the OneTrustGroupsUpdated and OneTrustLoaded events.
   *  If so, it returns true. Otherwise, it returns false.
   */
  const layerInitialized = function () {
    // check if the window object exists
    if (typeof window === 'undefined' || !window.dataLayer) {
      return false;
    }

    const OneTrustGroupsUpdated = window.dataLayer.findIndex((item) => item.event === 'OneTrustGroupsUpdated') !== -1;
    const OneTrustLoaded = window.dataLayer.findIndex((item) => item.event === 'OneTrustLoaded') !== -1;

    // return true if the dataLayer array contains both events
    return OneTrustGroupsUpdated && OneTrustLoaded;
  };

  const push = function (data) {
    if (!layerInitialized()) {
      return setTimeout(() => push(data), 20);
    }
    // Push directly to dataLayer (Nuxt 4 compatible - no useGtm dependency)
    if (window.dataLayer) {
      window.dataLayer.push(data);
    }
  };

  const pushNavigationEvent = (area, navigationItemPath) => {
    push(buildNavigationPayload(area, navigationItemPath));
  };

  return {
    provide: {
      _gtm: { push },
      _pushNavigationEvent: pushNavigationEvent,
    },
  };
});
